import { z } from "zod";

const machineTypeValues = [
	"CVPRange",
	"Em",
	"Fusion",
	"LantechCaseSealer",
	"PL1",
	"SealProX",
	"X4",
	"X5",
	"X6",
	"X7",
	"X5wPrint",
	"ZebraPrinter",
	"Everest",
	"Impack",
] as const;

export const machineTypeSchema = z.enum(machineTypeValues);

export type MachineType = z.infer<typeof machineTypeSchema>;

export const machineTypes: Record<MachineType, MachineType> = Object.fromEntries(
	machineTypeValues.map((machineType) => [machineType, machineType]),
) as Record<MachineType, MachineType>;

export const normalizeMachineType = (machineType: string | undefined): MachineType | undefined => {
	return machineTypeValues.find((knownMachineType) => knownMachineType.toLowerCase() === machineType?.toLowerCase());
};
